import { GDOCS } from '../constants'
import { getApplicationKey } from './getApplicationKey'

export function normalizeGDocsUrl(url) {
  if (getApplicationKey(url) === GDOCS && url.includes('/grading?'))
    return url.split('/grading?')[0]

  return url
}
